const contents = {
  // Customer
  'matters.matterDocuments.table.empty.text': 'No documents to show',
  'matters.matterDocuments.authorised.contact.info':
    'Please be aware that all authorised contacts in this audit matter can view ALL portal content and documents',
};

export default contents;
